/**
 * Mapea un código de estado a su correspondiente array de estados o viceversa
 * @param status Código de estado (ej. 'PND', 'SWB', etc.) o estado individual
 * @param inverse Si es true, busca el código que corresponde al estado individual
 * @returns Array de estados correspondientes o código de estado
 */
export const mapStatusToArray = (status: string, inverse: boolean = false): string[] | string => {
  // Definición de mapeo de estados
  const statusMap = {
    // Pendiente
    'PND': ['PND'],
    // Creado
    'SWB': ['SWB', 'HNR'],
    // Recolección
    'HCA': ['HCA', 'HCM', 'HRF'],
    // En transito
    'TRN': ['TRN', 'HTC', 'WHU', 'HLP', 'OTN', 'NRC', 'REO', 'RGS'],
    // Entregado
    'HDC': ['HDC', 'BDL'],
    // Cancelado
    'CWB': ['CWB', 'CBD', 'CDG', 'CGS', 'CLS', 'EOP', 'ERS', 'DEC', 'HCE', 'SIN'],
    // Devoluciones
    'HDR': ['HDR', 'RGR'],
    // Excepciones
    'EXL': ['EXL']
  };

  if (inverse) {
    // Buscar a qué categoría pertenece el estado individual
    for (const [key, values] of Object.entries(statusMap)) {
      if (values.includes(status)) {
        return key;
      }
    }
    return status; // Si no se encuentra, devolver el mismo status
  } else {
    // Comportamiento original: devolver array correspondiente al código
    return statusMap[status as keyof typeof statusMap] || [status];
  }
}; 

export const UserRoles = {
  ADMIN: 'admin',
  VIEWER: 'viewer',
  EDITOR: 'editor'
};

export const CSF_URL = 'https://api.guiasgrupomercurio.mx/csf/';

//export const API_URL = 'http://localhost:3000/api';
export const API_URL = 'https://api.guiasgrupomercurio.mx/api';
//export const PRINT_URL = 'http://qaglp.paquetexpress.mx:8083/wsReportPaquetexpress/GenCartaPorte?trackingNoGen=';
export const PRINT_URL = 'https://cc.paquetexpress.com.mx:8082/wsReportPaquetexpress/GenCartaPorte?trackingNoGen=';
